<template>
  <div class="root">
    <h1 class="page-title">レポート</h1>
    <!-- pc -->
    <div class="pc" v-if="device === 'pc'">
      <div v-if="hasData">
        <el-tabs type="card" v-model="selectedCameraName" @tab-click="tabClick">
          <el-tab-pane v-for="camera in dailyDataAll" :key="camera.camera_name" :name="camera.camera_name">
            <!--タブのラベル部-->
            <div slot="label" v-if="realtimeData(camera.camera_name).dataList[3].val === '高'"><el-badge class="item" value="x">{{camera.camera_name}}</el-badge></div>
            <div slot="label" v-else-if="realtimeData(camera.camera_name).dataList[3].val === '中'"><el-badge class="item" value="!" type="warning">{{camera.camera_name}}</el-badge></div>
            <div slot="label" v-else>{{camera.camera_name}}</div>

            <el-collapse v-model="activeNames" v-if="selectedCameraName == camera.camera_name">
              <!--リアルタイム情報-->
              <el-collapse-item title="リアルタイム人数" name="1">
                <el-row type="flex" v-if="activeNames.includes('1')">
                  <CurrentInfoCard :cameraData="realtimeData(camera.camera_name).dataList"/>
                  <AlertStatus :densityLevel="realtimeData(camera.camera_name).dataList[3].val" :threshold="camera.threshold"/>
                </el-row>
              </el-collapse-item>
              <!--時間帯別テーブル-->
              <el-collapse-item title="時間帯別人数" name="2">
                <ReportTable :reportData="camera" :propertys="dailyDataProps" v-if="activeNames.includes('2')" />
              </el-collapse-item>
              <!--時間帯別グラフ-->
              <el-collapse-item title="時間帯別最大人数グラフ" name="3">
                <ReportGraphData :cameraData="camera" v-if="activeNames.includes('3')" />
              </el-collapse-item>
            </el-collapse>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- sp -->
    <div class="mobile" v-else>
      <div v-if="hasData">
        <div class="select-camera">
          <span>表示カメラ：</span>
          <el-select v-model="selectedCameraName" placeholder="表示カメラ" @change="selectChange">
            <el-option v-for="camera in dailyDataAll" :key="camera.camera_name" :label="camera.camera_name" :value="camera.camera_name"></el-option>
          </el-select>
        </div>
        <el-collapse v-model="activeNames">
          <!--リアルタイム情報-->
          <el-collapse-item title="リアルタイム人数" name="1">
            <AlertStatus :densityLevel="realtimeData(selectedCameraName).dataList[3].val" :threshold="dailyData(selectedCameraName).threshold"/>
            <CurrentInfoCard :cameraData="realtimeData(selectedCameraName).dataList"/>
          </el-collapse-item>
          <!--時間帯別テーブル-->
          <el-collapse-item title="時間帯別人数" name="2">
            <ReportTable :reportData="dailyData(selectedCameraName)" :propertys="dailyDataProps" v-if="activeNames.includes('2')" />
          </el-collapse-item>
          <!--時間帯別グラフ-->
          <el-collapse-item title="時間帯別最大人数グラフ" name="3">
            <ReportGraphData :cameraData="dailyData(selectedCameraName)" v-if="activeNames.includes('3')" />
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

  </div>
</template>

<script>
import ReportTable from '@/components/report/ReportTable.vue';
import ReportGraphData from '@/components/report/ReportGraphData.vue';
import CurrentInfoCard from '@/components/report/CurrentInfoCard.vue';
import AlertStatus from '@/components/report/AlertStatus.vue';
import mixin from '@/mixin/mixin.js';

export default {

    mixins: [mixin],
    
    components: {
      CurrentInfoCard,
      ReportTable,
      ReportGraphData,
      AlertStatus
    },

    data() {
        return {
            activeNames: ['1'],
            selectedCamera: "",
        }
    },

    watch: {
      $route(to){
        // レポート画面 -> レポート画面遷移の時、queryは[undefined]
        if (typeof to.query.cameraName !== 'undefined') {
          this.selectedCameraName = to.query.cameraName
        }
      }
    },

    computed: {

      hasData: function(){
        return (Boolean(this.realtimeDataAll.length > 0 && this.dailyDataAll))
      },
      
      realtimeDataAll: function() {
        return this.$store.state.realtimeData
      },
      
      dailyDataAll: function() {
        return this.$store.state.dailyData.dataset
      },
      
      dailyDataProps: function() {
        return this.$store.state.dailyData.property
      },

      realtimeData: function() {
        return function(camera_name){
          var target = undefined
          target = this.realtimeDataAll.find(d => d.cameraName === camera_name)
          return target
        }
      },

      dailyData: function() {
        return function(camera_name){
          var target = undefined
          target = this.dailyDataAll.find(d => d.camera_name === camera_name) 
          return target
        }
      },

      selectedCameraName: {
        get() {
          if(this.hasData && this.selectedCamera){
            return this.selectedCamera
          }else if(this.hasData){
            return this.dailyDataAll[0].camera_name
          }else{
            return ""
          }
        },
        set(value){
          this.selectedCamera = value
        }
      },
    },

  created: function(){
    const param = this.$route.query.cameraName
    if(param){
      this.selectedCamera = param
    }
  },

  methods: {
    tabClick: function(tab){
      const cameraName = tab.name
      if(this.$route.query.cameraName !== cameraName){
        this.$router.push("/?cameraName=" + tab.name)
      }
    },

    selectChange: function(val){
      const cameraName = val
      if(this.$route.query.cameraName !== cameraName){
        this.$router.push("/?cameraName=" + val)
      }
    }
  }
};

</script>

<style scoped>
  .pc{
    display: block;
  }
  .page-title{
    font-size:20px;
  }

  .mobile {
    display: none;
  }
  .el-tabs >>> .el-tabs__nav-scroll{
    padding-top: 10px;
  }
  .current-info-card{
    max-width: 500px;
  }
  .alert-status{
    width: 700px;
    margin: auto;
  }

@media screen and (max-width: 980px) {
  .pc {
    display: none;
  }
  .mobile{
    display:block;
  }
  .select-camera{
    margin-bottom: 10px;
  }
  .current-info-card, .alert-status{
    padding: 10px;
    max-width: 500px;
    margin: auto;
  }
}

</style>